

















import { defineComponent, ref, toRef, watch } from "@vue/composition-api";
import { debounce } from "lodash-es";
import { BlockedLocationAutocomplete } from "@scrile/api-provider/dist/api/BlockedLocationsProvider";
import providers from "@/lib/api";
import { getCountryName, getStateName } from "@/lib/i18nHelpers";
import { FormValue } from "@/types";
import BaseInput from "@/components/BaseInput";
import CustomScroll from "@/components/CustomScroll";

export default defineComponent({
  name: "LocationSearchInput",
  components: { CustomScroll, BaseInput },
  props: {
    location: { type: String, default: "" },
  },
  setup(props, { emit }) {
    const locationCity = ref<FormValue>("");
    const showOptions = ref(false);
    const options = ref<(BlockedLocationAutocomplete & { text: string })[]>([]);

    const mappedLocations = (locations: BlockedLocationAutocomplete[]) => {
      return locations.map(item => {
        let result = "";
        if (item.countryCode) {
          result += getCountryName(item.countryCode);
        }

        if (item.stateCode && item.countryCode) {
          result += `, ${getStateName(item.stateCode, item.countryCode)}`;
        }

        if (item.city) {
          result += `, ${item.city}`;
        }

        return {
          text: result,
          ...item,
        };
      });
    };

    const getLocations = debounce(async (text?: string) => {
      if (!text) {
        showOptions.value = false;
        emit("setValid", false);
        return;
      }
      const response = await providers.BlockedLocationsProvider.searchAutocomplete({ text });
      options.value = mappedLocations(response);
      if (options.value.length) showOptions.value = true;
      else showOptions.value = false;
    }, 500);

    const setLocation = (value: BlockedLocationAutocomplete & { text: string }) => {
      if (!locationCity.value) return;
      emit("setLocation", value);
      emit("setValid", true);
      locationCity.value = value.text;
      showOptions.value = false;
    };

    watch(toRef(props, "location"), value => (locationCity.value = value));

    return {
      locationCity,
      showOptions,
      options,
      getLocations,
      setLocation,
    };
  },
});
